<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay" v-on:click="close(false)"></div>
      <div class="modalContent">
        <div class="resetCnt">
          <div class="resetBtn" v-on:click="close(true, null)">Reset Color</div>
        </div>
        <Chrome v-model="color"/>
        <Slider v-model="color" v-if="1>2"/>
        <div class="modalAction">
          <button class="btn btnSecondary" v-on:click="close()">
            Cancel</button>
          <button class="btn btnPrimary" v-on:click="saveNow">
            <span>Set Color</span>
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { Chrome, Slider } from 'vue-color';

export default {
  name: 'colorPicker',
  components: { Chrome, Slider },
  data() {
    return {
      show: false,
      next: null,
      color: '#EEEEEE',
    };
  },
  methods: {
    open(d, next) {
      this.color = (d && d.color) ? d.color : '#EEEEEE';
      this.show = true;
      this.next = next;
    },
    close(b, color) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b, color);
    },
    saveNow() {
      const color = (this.color.hex) ? this.color.hex : this.color;
      this.close(true, color);
    },
  },
};
</script>

<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 99991;
    display: flex;
    align-items: center;
    justify-content: center;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0,0,0,.7);
      z-index: 1;
      // backdrop-filter: saturate(180%) blur(20px);
      opacity: 1;
    }
    .modalContent{
      position: absolute;
      background-color: #fff;
      z-index: 2;
      // padding: 30px 40px;
      border-radius: 5px;
      margin-top: -20px;
      overflow: hidden;
      .resetCnt{
        padding: 6px;
        .resetBtn{
          padding: 8px 10px;
          border-radius: 3px;
          border: none;
          cursor: pointer;
          transition: all .3s ease;
          padding-left: 38px;
          position: relative;
          &:before{
            content: "";
            position: absolute;
            left: 10px; top: 0; bottom: 0; width: 20px;
            background-image: url(../assets/ban-square.png);
            background-size: 16px auto;
            background-position: center;
            background-repeat: no-repeat;
          }
          &:hover{
            background-color: #eee;
          }
        }
      }
      .modalAction{
        margin: 0;
        padding: 8px 10px;
        text-align: right;
        // background-color: #eee;
        border-top: #eee 1px solid;
        position: relative;
        z-index: 3;
        background-color: #fff;
        .btn{
          margin-left: 5px;
          font-size: 14px;
          padding: 10px 12px;
          &.disabled{
            background-color: #ddd;
            color: #999;
            box-shadow: none;
            cursor: default;
          }
        }
      }
    }
  }
</style>
